// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"InputToPopUp-module__inputContainer","textSearchBorder":"InputToPopUp-module__textSearchBorder","errorMsg":"InputToPopUp-module__errorMsg"};